<template>
  <div class="ctx-menu" :style="style" :hidden="!ctxMenuWidget" v-click-outside="resetCtx">
    <!-- Check if there are options data -->
    <template v-if="ctxMenuWidget">
      <div class="context-menu-container">
        <component :is="ctxMenuWidget.component" v-bind="ctxMenuWidget.props" />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ContextMenu',
  data: () => ({
    ctxMenuWidget: null,
    style: null,
    ctxMenuRect: null,
    // {
    //   y:number,
    //   x:number
    // }
  }),
  methods: {
    resetCtx() {
      this.ctxMenuWidget = null;
      this.ctxMenuData = null;
      this.ctxMenuRect = null;
    },
    onContextMenu(ev, ctxMenuWidget) {
      // prevent default behaviours
      ev.preventDefault();
      ev.stopPropagation();
      this.ctxMenuWidget = ctxMenuWidget;
      this.ctxMenuRect = {
        x: ev.x,
        y: ev.y,
      };
      // then reevaluate and set context-menu position
      this.reevaluatePosition();
    },
    async reevaluatePosition() {
      if (this.ctxMenuRect) {
        // using $nextTick to daley and make sure that the context-menu
        // options are fully rendered which will help us
        // to get the accurate height
        await this.$nextTick();
        await this.$nextTick();
        let { x, y } = this.ctxMenuRect;
        // get the window current inner height and width
        let { innerHeight, innerWidth } = window;
        // get the component height and width through element.getClientRects
        let { height, width } = this.$el.getClientRects()[0];
        // then subtract window inner height and width with
        // context-menu event source points (x, y)
        let dY = innerHeight - y;
        let dX = innerWidth - x;
        // check if the context-menu height is not
        // longer than the available
        if (dY < height) {
          y = y - height;
        }
        if (dX < width) {
          x = x - width;
        }
        // set the position
        this.style = {
          left: x + 'px',
          top: y + 'px',
        };
      }
    },
  },
  mounted() {
    // Listen on contextmenu event through the $root instance
    this.$root.$on('contextmenu', (data) => {
      // if the data is null reset and handler the action
      if (data === null) this.resetCtx();
      else this.onContextMenu(data.event, data.ctxMenuWidget);
    });

    this.$root.$on('closeContextmenu', () => {
      this.resetCtx();
    });
  },
  beforeDestroy() {
    this.$root.$off('contextmenu', () => {});
  },
};
</script>

<style scoped>
.ctx-menu {
  position: fixed;
  z-index: 1111111;
}

.context-menu-container {
  height: fit-content;
  box-shadow: 0px 3px 6px #00000029;
  border: 2px solid #ff8f7c;
  background: #ffffff;
  border-radius: 8px;
  padding: 10px;
}
</style>
